export  default  {
    // 一级
    homePage: "首页",
    系统管理: "系统管理",
    系统监控: "系统监控",
    系统工具: "系统工具",
    // 二级
    日志管理: "日志管理",
    用户管理: "用户管理",
    角色管理: "角色管理",
    菜单管理: "菜单管理",
    部门管理: "部门管理",
    岗位管理: "岗位管理",
    字典管理: "字典管理",
    参数管理: "参数管理",
    通知公告: "通知公告",
    操作日志: "操作日志",
    登录日志: "登录日志",
    定时任务: "定时任务",
    表单构建: "表单构建",
    代码生成: "代码生成",
    系统接口: "系统接口",
    Sentinel控制台:"Sentinel控制台",
    Nacos控制台:"Nacos控制台",
    Admin控制台:"Admin控制台",


}
